(() => {
  const inputSelector = '.card-color-swatches__input';

  function getCardMainImg(el) {
    const card = el.closest('.card-wrapper, .card');
    if (!card) return null;

    return card.querySelector('.card__media img');
  }

  function applyVariantImage(input) {
    if (!input) return;

    const img = getCardMainImg(input);
    if (!img) return;

    const vSrc = input.dataset.variantImg;
    const vSrcset = input.dataset.variantSrcset;

    if (vSrc) img.setAttribute('src', vSrc);
    if (vSrcset) {
      img.setAttribute('srcset', vSrcset);
    } else {
      img.removeAttribute('srcset');
    }
  }

  function applyCheckedSwatchInScope(scope = document) {
    const checkedInputs = scope.querySelectorAll(`${inputSelector}:checked`);
    checkedInputs.forEach(applyVariantImage);
  }

  document.addEventListener('change', (e) => {
    const input = e.target.closest(inputSelector);
    if (!input) return;

    applyVariantImage(input);

  });

  document.addEventListener('DOMContentLoaded', () => {
    applyCheckedSwatchInScope(document);
  });

  document.addEventListener('shopify:section:load', (e) => {
    applyCheckedSwatchInScope(e.target);
  });
})();